// extracted by mini-css-extract-plugin
export default {"Searchbox":"Searchbox_Searchbox__Ux6uL","searchResult":"Searchbox_searchResult__lOpSe","SearchIcon":"Searchbox_SearchIcon__Rt5RJ","hoverCursor":"Searchbox_hoverCursor__H3rtq"};